export const cognitoConfig: { userPoolId: string; clientId: string } = {
    userPoolId: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID as string,
    clientId: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID as string
}
